module.exports = __webpack_public_path__ + "img/2-min.97f4214a.jpg";